import { render } from "./Uptd.vue?vue&type=template&id=5ad4ef98"
import script from "./Uptd.vue?vue&type=script&lang=js"
export * from "./Uptd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__